import React, { useEffect, useState } from 'react';
import { Box, Typography, Grid, Card, CardMedia, CardContent, Button, makeStyles, Container } from '@material-ui/core';
import { Link } from 'react-router-dom';
const useStyles = makeStyles((theme) => ({
    root: {
        // padding: theme.spacing(3),
        // backgroundColor: '#f4f6f8', // Màu nền trang
    },
    title: {
        // textAlign: 'center',
        marginBottom: theme.spacing(3),
        fontWeight: 'bold',
        fontSize: '1.8rem',
        color: '#0277bd',
        textDecoration: 'underline'
    },
    card: {
        [theme.breakpoints.up('md')]: {
            maxWidth: 355,
        },
        with: '100%',
        padding: '0 20px',
        height: '100%',
        margin: '10px',
        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(122, 94, 94, 0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
        display: 'flex',
        flexDirection: 'column',
        '&:hover $mediaChild': { // Áp dụng style cho mediaChild khi hover vào parentContainer
            transform: 'scale(1.1)'
        }
    },
    media: {
        height: 200,
    },
    mediaChild: {
        height: 150,
        margin: theme.spacing(7), // Margin mặc định cho màn hình nhỏ hơn
        transition: 'transform 0.3s ease-in-out',
        [theme.breakpoints.up('md')]: {
            margin: theme.spacing(2), // Margin cho màn hình medium trở lên
        },
    },
    cardContent: {
        flexGrow: 1,
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
    },
    carName: {
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
        fontSize: '1.5rem',
        color: '#212121',
    },
    price: {
        color: '#d32f2f',
        fontWeight: 'bold',
        fontSize: '1.1rem',
        marginBottom: theme.spacing(1),
    },
    button: {
        backgroundColor: '#1976d2',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#1565c0',
        },
    },
    gridDanhSach: {
        marginBottom: '15px'
    },
    priceButton: {
        marginTop: 'auto',
    },
    button2: {
        marginTop: 16,
        backgroundColor: '#00095b',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#1700f4',
        },
    },
    thongSo: {
        marginTop: theme.spacing(3),
        // backgroundColor: '#f7f7f7',
    },
    titleThongSo: {
        color: '#00095b',
        fontWeight: 700
    },
    link: {
        textDecoration: 'none !important',
        color: 'inherit !important', // Kế thừa màu từ button
        '&:hover': {
            textDecoration: 'none !important',
            color: 'inherit !important',
        },
        '&:focus': {
            outline: 'none !important',
        },
    }
}));

const TransitPage = () => {
    const classes = useStyles();
    const transit = [
        {
            ten: 'TRANSIT PREMIUM+ 18 CHỖ',
            anh: 'https://www.ford.com.vn/content/dam/ecomm/VN/namepate/transit/compare/transit-premium-plus.jpg',
            thongSo: [
                {
                    title: 'Động cơ & Tính năng Vận hành',
                    content: [
                        'Động cơ : Turbo Diesel 2.3L - TDCi',
                        'Trục cam kép, có làm mát khí nạp',
                        'Dung tích xi lanh (cc) : 2296',
                        'Công suất cực đại (PS/vòng/phút) : 171 (126 kW) / 3200',
                        'Mô men xoắn cực đại (Nm/vòng/phút) : 425 / 1400 - 2400',
                        'Hộp số : 6 cấp số sàn',
                        'Ly hợp : Đĩa ma sát khô, dẫn động bằng thuỷ lực',
                        'Trợ lực lái thủy lực : Có',
                    ],
                },
                {
                    title: 'Kích thước',
                    content: [
                        'Dài x Rộng x Cao (mm) : 6703 x 2164 x 2775',
                        'Chiều dài cơ sở (mm) : 3750',
                        'Vệt bánh trước (mm) : 1740',
                        'Vệt bánh sau (mm) : 1702',
                        'Khoảng sáng gầm xe (mm) : 150',
                        'Bán kính vòng quay nhỏ nhất (m) : 6.7',
                        'Dung tích thùng nhiên liệu (L) : 80',
                    ],
                },
                {
                    title: 'Hệ thống treo',
                    content: [
                        'Trước : Hệ thống treo độc lập dùng lò xo trụ, thanh cân bằng và ống giảm chấn thủy lực',
                        'Sau : Hệ thống treo phụ thuộc dùng nhíp lá, thanh cân bằng với ống giảm chấn thủy lực',
                    ],
                },
                {
                    title: 'Hệ thống phanh',
                    content: [
                        'Phanh trước và sau : Phanh Đĩa',
                        'Cỡ lốp : 195 / 75R16C (Trước đơn - Sau đôi)',
                        'Vành xe : Vành thép 16"',
                    ],
                },
                {
                    title: 'Trang thiết bị an toàn',
                    content: [
                        'Túi khí phía trước cho người lái : Có',
                        'Túi khí cho hành khách phía trước : Có',
                        'Dây đai an toàn đa điểm cho tất cả các ghế : Có',
                        'Camera lùi : Có',
                        'Cảm biến hỗ trợ đỗ xe sau : Có',
                        'Hệ thống Chống bó cứng phanh & Phân phối lực phanh điện tử : Có',
                        'Hệ thống Cân bằng điện tử : Có',
                        'Hệ thống Kiểm soát hành trình : Có',
                        'Hệ thống Chống trộm : Có',
                    ],
                },
                {
                    title: 'Trang thiết bị ngoại thất',
                    content: [
                        'Đèn phía trước : LED, tự động bật đèn',
                        'Đèn chạy ban ngày : LED',
                        'Đèn sương mù : LED',
                        'Gạt mưa tự động : Có',
                        'Gương chiếu hậu ngoài : Chỉnh điện và gập điện',
                        'Bậc bước chân điện : Có',
                        'Cửa trượt điện : Có',
                        'Chắn bùn trước sau : Có',
                    ],
                },
                {
                    title: 'Trang thiết bị bên trong xe',
                    content: [
                        'Điều hoà nhiệt độ : Tự động',
                        'Cửa gió điều hòa hành khách : Có',
                        'Chất liệu ghế : Nỉ kết hợp Vinyl',
                        'Điều chỉnh ghế lái : Chỉnh 6 hướng, có tựa tay',
                        'Điều chỉnh hàng ghế sau : Điều chỉnh ngả, có tựa tay',
                        'Hàng ghế cuối gập phẳng : Có',
                        'Tay nắm hỗ trợ lên xuống : Có',
                        'Giá hành lý phía trên : Có',
                        'Cửa kính điều khiển điện : Có (1 chạm lên xuống cho hàng ghế trước)',
                        'Bảng đồng hồ tốc độ : Màn hình 12.3"',
                        'Màn hình trung tâm : Màn hình TFT cảm ứng 12.3"',
                        'Kết nối Apple Carplay & Android Auto : Không dây',
                        'Hệ thống âm thanh : AM/FM, Bluetooth, USB, 6 loa',
                        'Điều khiển âm thanh trên tay lái : Có',
                        'Cổng sạc USB cho hàng ghế sau : Có',
                    ],
                },
                {
                    title: 'Trang thiết bị phần cứng cho bộ giải pháp Upfleet',
                    content: [
                        'Thiết bị giám sát hành trình GPS : Tùy chọn tại Đại lý',
                        'Thiết bị giám sát hình ảnh : Tùy chọn tại Đại lý',
                    ],
                },
            ],
            tenLink: 'ford-transit-premium-plus-18'
        },
        {
            ten: 'TRANSIT PREMIUM 16 CHỖ',
            anh: 'https://www.ford.com.vn/content/dam/ecomm/VN/namepate/transit/compare/transit-premium.jpg',
            thongSo: [
                {
                    title: 'Động cơ & Tính năng Vận hành',
                    content: [
                        'Động cơ : Turbo Diesel 2.3L - TDCi',
                        'Trục cam kép, có làm mát khí nạp',
                        'Dung tích xi lanh (cc) : 2296',
                        'Công suất cực đại (PS/vòng/phút) : 171 (126 kW) / 3200',
                        'Mô men xoắn cực đại (Nm/vòng/phút) : 425 / 1400 - 2400',
                        'Hộp số : 6 cấp số sàn',
                        'Ly hợp : Đĩa ma sát khô, dẫn động bằng thuỷ lực',
                        'Trợ lực lái thủy lực : Có',
                    ],
                },
                {
                    title: 'Kích thước',
                    content: [
                        'Dài x Rộng x Cao (mm) : 5998 x 2068 x 2775',
                        'Chiều dài cơ sở (mm) : 3750',
                        'Vệt bánh trước (mm) : 1734',
                        'Vệt bánh sau (mm) : 1759',
                        'Khoảng sáng gầm xe (mm) : 150',
                        'Bán kính vòng quay nhỏ nhất (m) : 6.7',
                        'Dung tích thùng nhiên liệu (L) : 80',
                    ],
                },
                {
                    title: 'Hệ thống treo',
                    content: [
                        'Trước : Hệ thống treo độc lập dùng lò xo trụ, thanh cân bằng và ống giảm chấn thủy lực',
                        'Sau : Hệ thống treo phụ thuộc dùng nhíp lá với ống giảm chấn thủy lực',
                    ],
                },
                {
                    title: 'Hệ thống phanh',
                    content: [
                        'Phanh trước và sau : Phanh Đĩa',
                        'Cỡ lốp : 235 / 65R16C',
                        'Vành xe : Vành hợp kim 16"',
                    ],
                },
                {
                    title: 'Trang thiết bị an toàn',
                    content: [
                        'Túi khí phía trước cho người lái : Có',
                        'Túi khí cho hành khách phía trước : Có',
                        'Dây đai an toàn đa điểm cho tất cả các ghế : Có',
                        'Camera lùi : Có',
                        'Cảm biến hỗ trợ đỗ xe sau : Có',
                        'Hệ thống Chống bó cứng phanh & Phân phối lực phanh điện tử : Có',
                        'Hệ thống Cân bằng điện tử : Có',
                        'Hệ thống Kiểm soát hành trình : Có',
                        'Hệ thống Chống trộm : Có',
                    ],
                },
                {
                    title: 'Trang thiết bị ngoại thất',
                    content: [
                        'Đèn phía trước : LED, tự động bật đèn',
                        'Đèn chạy ban ngày : LED',
                        'Đèn sương mù : LED',
                        'Gạt mưa tự động : Có',
                        'Gương chiếu hậu ngoài : Chỉnh điện và gập điện',
                        'Bậc bước chân điện : Có',
                        'Cửa trượt điện : Có',
                        'Chắn bùn trước sau : Có',
                    ],
                },
                {
                    title: 'Trang thiết bị bên trong xe',
                    content: [
                        'Điều hoà nhiệt độ : Tự động',
                        'Cửa gió điều hòa hành khách : Có',
                        'Chất liệu ghế : Nỉ kết hợp Vinyl',
                        'Điều chỉnh ghế lái : Chỉnh 6 hướng, có tựa tay',
                        'Điều chỉnh hàng ghế sau : Điều chỉnh ngả, có tựa tay',
                        'Hàng ghế cuối gập phẳng : Có',
                        'Tay nắm hỗ trợ lên xuống : Có',
                        'Giá hành lý phía trên : Có',
                        'Cửa kính điều khiển điện : Có (1 chạm lên xuống cho hàng ghế trước)',
                        'Bảng đồng hồ tốc độ : Màn hình 12.3"',
                        'Màn hình trung tâm : Màn hình TFT cảm ứng 12.3"',
                        'Kết nối Apple Carplay & Android Auto : Không dây',
                        'Hệ thống âm thanh : AM/FM, Bluetooth, USB, 6 loa',
                        'Điều khiển âm thanh trên tay lái : Có',
                        'Cổng sạc USB cho hàng ghế sau : Có',
                    ],
                },
                {
                    title: 'Trang thiết bị phần cứng cho bộ giải pháp Upfleet',
                    content: [
                        'Thiết bị giám sát hành trình GPS : Tùy chọn tại Đại lý',
                        'Thiết bị giám sát hình ảnh : Tùy chọn tại Đại lý',
                    ],
                },
            ],
            tenLink: 'ford-transit-premium-16'
        },
        {
            ten: 'TRANSIT TREND 16 CHỖ',
            anh: 'https://www.ford.com.vn/content/dam/ecomm/VN/namepate/transit/compare/transit-trend.jpg',
            thongSo: [
                {
                    title: 'Động cơ & Tính năng Vận hành',
                    content: [
                        'Động cơ : Turbo Diesel 2.3L - TDCi',
                        'Trục cam kép, có làm mát khí nạp',
                        'Dung tích xi lanh (cc) : 2296',
                        'Công suất cực đại (PS/vòng/phút) : 171 (126 kW) / 3200',
                        'Mô men xoắn cực đại (Nm/vòng/phút) : 425 / 1400 - 2400',
                        'Hộp số : 6 cấp số sàn',
                        'Ly hợp : Đĩa ma sát khô, dẫn động bằng thuỷ lực',
                        'Trợ lực lái thủy lực : Có',
                    ],
                },
                {
                    title: 'Kích thước',
                    content: [
                        'Dài x Rộng x Cao (mm) : 5998 x 2068 x 2485',
                        'Chiều dài cơ sở (mm) : 3750',
                        'Vệt bánh trước (mm) : 1734',
                        'Vệt bánh sau (mm) : 1759',
                        'Khoảng sáng gầm xe (mm) : 150',
                        'Bán kính vòng quay nhỏ nhất (m) : 6.7',
                        'Dung tích thùng nhiên liệu (L) : 80',
                    ],
                },
                {
                    title: 'Hệ thống treo',
                    content: [
                        'Trước : Hệ thống treo độc lập dùng lò xo trụ, thanh cân bằng và ống giảm chấn thủy lực',
                        'Sau : Hệ thống treo phụ thuộc dùng nhíp lá với ống giảm chấn thủy lực',
                    ],
                },
                {
                    title: 'Hệ thống phanh',
                    content: [
                        'Phanh trước và sau : Phanh Đĩa',
                        'Cỡ lốp : 235 / 65R16C',
                        'Vành xe : Vành hợp kim 16"',
                    ],
                },
                {
                    title: 'Trang thiết bị an toàn',
                    content: [
                        'Túi khí phía trước cho người lái : Có',
                        'Túi khí cho hành khách phía trước : Không',
                        'Dây đai an toàn đa điểm cho tất cả các ghế : Có',
                        'Camera lùi : Có',
                        'Cảm biến hỗ trợ đỗ xe sau : Có',
                        'Hệ thống Chống bó cứng phanh & Phân phối lực phanh điện tử : Có',
                        'Hệ thống Cân bằng điện tử : Có',
                        'Hệ thống Kiểm soát hành trình : Có',
                        'Hệ thống Chống trộm : Có',
                    ],
                },
                {
                    title: 'Trang thiết bị ngoại thất',
                    content: [
                        'Đèn phía trước : LED',
                        'Đèn chạy ban ngày : LED',
                        'Đèn sương mù : Halogen',
                        'Gạt mưa tự động : Không',
                        'Gương chiếu hậu ngoài : Chỉnh điện và gập điện',
                        'Bậc bước chân điện : Có',
                        'Cửa trượt điện : Không',
                        'Chắn bùn trước sau : Có',
                    ],
                },
                {
                    title: 'Trang thiết bị bên trong xe',
                    content: [
                        'Điều hoà nhiệt độ : Điều chỉnh tay',
                        'Cửa gió điều hòa hành khách : Có',
                        'Chất liệu ghế : Nỉ kết hợp Vinyl',
                        'Điều chỉnh ghế lái : Chỉnh 6 hướng',
                        'Điều chỉnh hàng ghế sau : Điều chỉnh ngả',
                        'Hàng ghế cuối gập phẳng : Không',
                        'Tay nắm hỗ trợ lên xuống : Có',
                        'Giá hành lý phía trên : Không',
                        'Cửa kính điều khiển điện : Có (1 chạm lên xuống cho hàng ghế trước)',
                        'Bảng đồng hồ tốc độ : Màn hình 3.5"',
                        'Màn hình trung tâm : Màn hình TFT cảm ứng 8"',
                        'Kết nối Apple Carplay & Android Auto : Không',
                        'Hệ thống âm thanh : AM/FM, Bluetooth, USB, 6 loa',
                        'Điều khiển âm thanh trên tay lái : Có',
                        'Cổng sạc USB cho hàng ghế sau : Không',
                    ],
                },
                {
                    title: 'Trang thiết bị phần cứng cho bộ giải pháp Upfleet',
                    content: [
                        'Thiết bị giám sát hành trình GPS : Tùy chọn tại Đại lý',
                        'Thiết bị giám sát hình ảnh : Tùy chọn tại Đại lý',
                    ],
                },
            ],
            tenLink: 'ford-transit-trend-16'
        }
    ]

    return (
        <Container maxWidth='lg'>
            <Grid container>
                {transit.map((xe, index) => (
                    <Grid item key={index} xs={12} sm={6} md={4} className={classes.gridDanhSach}>
                        <Card className={classes.card}>
                            <Box className={classes.media}>
                                <CardMedia
                                    className={classes.mediaChild}
                                    image={xe.anh}
                                    title={xe.ten}
                                />
                            </Box>
                            <CardContent className={classes.cardContent}>
                                <Box>
                                    <Typography variant="subtitle1" className={classes.carName}>
                                        {xe.ten}
                                    </Typography>
                                    <Box className={classes.priceButton}>
                                        <Typography variant="subtitle2" className={classes.price}>
                                            {xe.gia} VNĐ
                                        </Typography>
                                        <Button variant="contained" href={`/dang-ky-lai-thu/${xe.tenLink}`} className={classes.button} fullWidth>
                                            Đăng ký lái thử
                                        </Button>
                                        <Button variant="contained" className={classes.button2} fullWidth>
                                            <Link to={`/bao-gia/${xe.tenLink}`} className={classes.link}>
                                                Yêu cầu báo giá
                                            </Link>

                                        </Button>
                                    </Box>
                                </Box>
                                <Box className={classes.thongSo}>
                                    {xe.thongSo.map((thongSo, index) => (
                                        <Box>
                                            <Typography variant="subtitle1" className={classes.titleThongSo}>
                                                {thongSo.title}
                                            </Typography>
                                            <Box>
                                                <ul>
                                                    {thongSo.content.map((item, index) => (
                                                        <li>{item}</li>
                                                    ))}
                                                </ul>
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default TransitPage;
